import React, { useState, useEffect, useRef } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
export default function FooterSection() {
  const [formData, setFormData] = useState({
    nombre: "",
    celular: "",
    ciudad: "",
    email: "",
    tipo: ""
  });
  const sectionRef = useRef<HTMLElement>(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) setVisible(true);
    }, {
      threshold: 0.1
    });
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };
  return <section ref={sectionRef} className="dark" style={{
    fontFamily: "'Space Grotesk', sans-serif"
  }}>
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@300;400;500;600;700&family=Playfair+Display:wght@700&display=swap');`}</style>

      <div className="bg-background text-foreground">
        <div className={`max-w-7xl mx-auto px-6 lg:px-12 pt-20 pb-16 transition-all duration-1000 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-16 lg:gap-8">

            <div className="lg:col-span-5">
              <div className="relative mb-10">
                <span className="block text-xs font-semibold tracking-[0.3em] text-muted-foreground uppercase mb-2">
                  Hablemos
                </span>
                <h2 style={{
                fontFamily: "'Playfair Display', serif"
              }} className="text-5xl lg:text-6xl font-bold text-foreground leading-none">
                  CONTÁCTENOS
                </h2>
                <div className="mt-4 h-px w-20 bg-primary" />
              </div>

              <div className="space-y-5">
                <div className="group">
                  <Label htmlFor="nombre" className="block text-xs tracking-widest uppercase text-muted-foreground mb-1.5 group-focus-within:text-primary transition-colors">
                    Nombre y apellido*
                  </Label>
                  <Input id="nombre" name="nombre" value={formData.nombre} onChange={handleChange} className="bg-card border-border border rounded-none h-12 text-foreground placeholder:text-muted-foreground focus:border-primary focus:ring-0 transition-colors" />
                </div>

                <div className="group">
                  <Label htmlFor="celular" className="block text-xs tracking-widest uppercase text-muted-foreground mb-1.5 group-focus-within:text-primary transition-colors">
                    Número celular
                  </Label>
                  <Input id="celular" name="celular" value={formData.celular} onChange={handleChange} className="bg-card border-border border rounded-none h-12 text-foreground placeholder:text-muted-foreground focus:border-primary focus:ring-0 transition-colors" />
                </div>

                <div className="grid grid-cols-2 gap-4">
                  <div className="group">
                    <Label htmlFor="ciudad" className="block text-xs tracking-widest uppercase text-muted-foreground mb-1.5 group-focus-within:text-primary transition-colors">
                      Ciudad*
                    </Label>
                    <Input id="ciudad" name="ciudad" value={formData.ciudad} onChange={handleChange} className="bg-card border-border border rounded-none h-12 text-foreground placeholder:text-muted-foreground focus:border-primary focus:ring-0 transition-colors" />
                  </div>

                  <div className="group">
                    <Label htmlFor="email" className="block text-xs tracking-widest uppercase text-muted-foreground mb-1.5 group-focus-within:text-primary transition-colors">
                      Email*
                    </Label>
                    <Input id="email" name="email" type="email" value={formData.email} onChange={handleChange} className="bg-card border-border border rounded-none h-12 text-foreground placeholder:text-muted-foreground focus:border-primary focus:ring-0 transition-colors" />
                  </div>
                </div>

                <div className="group">
                  <Label htmlFor="tipo" className="block text-xs tracking-widest uppercase text-muted-foreground mb-1.5 group-focus-within:text-primary transition-colors">
                    Soy paciente o Doctor? *
                  </Label>
                  <Input id="tipo" name="tipo" value={formData.tipo} onChange={handleChange} className="bg-card border-border border rounded-none h-12 text-foreground placeholder:text-muted-foreground focus:border-primary focus:ring-0 transition-colors" />
                </div>

                <p className="text-xs text-muted-foreground leading-relaxed pt-1">
                  Al hacer clic en Enviar, aceptas que Rio3D almacene y procese la información
                  personal suministrada arriba para proporcionarte el contenido solicitado. Para
                  obtener información sobre cómo darte de baja, así como nuestra{" "}
                  <a href="#" className="underline underline-offset-2 hover:text-primary transition-colors">
                    Política de privacidad
                  </a>
                </p>

                <Button className="text-sm bg-primary inline-flex items-center justify-center gap-2 whitespace-nowrap [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive shadow-xs px-4 py-2 has-[>svg]:px-3 mt-2 w-full rounded-none h-12 tracking-[0.25em] uppercase font-semibold transition-opacity !bg-[rgba(8,215,247,1)] !text-xl !font-mono !text-[rgba(255,255,255,1)] disabled:pointer-events-none disabled:opacity-50 dark:aria-invalid:ring-destructive/40 hover:bg-primary/90 hover:opacity-90">
                  Enviar
                </Button>
              </div>
            </div>

            <div className="lg:col-span-2 flex flex-col">
              <div className="relative mb-10">
                <span className="block text-xs font-semibold tracking-[0.3em] text-muted-foreground uppercase mb-2">
                  Navegación
                </span>
                <h2 style={{
                fontFamily: "'Playfair Display', serif"
              }} className="text-5xl lg:text-6xl font-bold text-foreground leading-none">
                  MENÚ
                </h2>
                <div className="mt-4 h-px w-20 bg-primary" />
              </div>

              <nav className="flex flex-col space-y-0">
                {["SOY PACIENTE", "SOY DOCTOR", "ENCUENTRE UN DOCTOR", "PREGUNTAS FRECUENTES"].map((item, i) => <a key={i} href="#" className="group flex items-center gap-3 py-4 border-b border-border hover:border-primary transition-colors">
                    <span className="text-xs text-muted-foreground font-mono w-5 shrink-0">
                      0{i + 1}
                    </span>
                    <span className="text-sm font-medium tracking-wider text-foreground group-hover:text-primary transition-colors">
                      {item}
                    </span>
                  </a>)}
              </nav>
            </div>

            <div className="lg:col-span-5 flex flex-col">
              <div className="relative mb-10">
                <span className="block text-xs font-semibold tracking-[0.3em] text-muted-foreground uppercase mb-2">
                  Multimedia
                </span>
                <h2 style={{
                fontFamily: "'Playfair Display', serif"
              }} className="text-5xl lg:text-6xl font-bold text-foreground leading-none">
                  VIDEO
                </h2>
                <div className="mt-4 h-px w-20 bg-primary" />
              </div>

              <div className="relative flex-1 min-h-[280px] lg:min-h-0 bg-card border border-border overflow-hidden group">
                <div className="absolute inset-0 bg-gradient-to-br from-primary/5 to-transparent pointer-events-none z-10" />
                <iframe className="w-full h-full min-h-[280px] lg:min-h-[340px]" src="https://www.youtube.com/embed/dQw4w9WgXcQ" title="Dental Monitoring - Advertisement for Patients (English) - YouTube" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen />
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-background/80 to-transparent h-16 pointer-events-none z-10" />
              </div>

              <div className="mt-4 p-4 bg-card border border-border">
                <p className="text-xs text-muted-foreground tracking-wide">
                  Dental Monitoring - Advertisement for Patients (English)
                </p>
                <p className="text-xs text-muted-foreground/60 mt-1">
                  DentalMonitoring · 3.38K subscribers
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-border bg-card">
          <div className="max-w-7xl mx-auto px-6 lg:px-12 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-muted-foreground tracking-widest uppercase text-center sm:text-left">
              Copyright © 2026 LABORATORIO ALINEADORES DENTALES RIO 3D | Colombia
            </p>
            <div className="flex items-center gap-2">
              <div className="h-1.5 w-1.5 rounded-full bg-primary animate-pulse" />
              <span className="text-xs text-muted-foreground tracking-wider">
                Powered by Joinchat
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}